import { ILmsProfileModel } from 'models/lmsProfile.model'
import api from '../../..'

const createProfileSegments = (id: number | string, segments: number[]) =>
  api
    .post(`administration/lms_profiles/${id}/segments`, {
      segment_ids: segments,
    })
    .then(({ data }): ILmsProfileModel => data)

export default createProfileSegments
